import { TransitionComponent } from "./chunk-QUQRJRHE.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Dropdown/Dropdown.Panel.tsx
import { forwardRef, Fragment } from "react";
import clsx from "clsx";
import { PopoverPanel } from "@headlessui/react";
import { jsx } from "react/jsx-runtime";
var DROPDOWN_PANEL_CLASSNAME_MAP = {
  position: {
    top: "pd:bottom-full pd:mb-2",
    bottom: "pd:top-full pd:mt-2"
  }
};
var DropdownPanel = forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      position = "bottom",
      unmount,
      className
    } = _b,
    rest = __objRest(_b, ["children", "position", "unmount", "className"]);
  return /* @__PURE__ */jsx(TransitionComponent, {
    as: Fragment,
    variant: position === "bottom" ? "appear-from-top" : "appear-from-bottom",
    unmount,
    children: /* @__PURE__ */jsx(PopoverPanel, __spreadProps(__spreadValues({
      ref,
      focus: true
    }, rest), {
      static: true,
      className: clsx("pd:dropdown__panel", DROPDOWN_PANEL_CLASSNAME_MAP.position[position], className),
      children
    }))
  });
});
var Dropdown_Panel_default = DropdownPanel;
export { Dropdown_Panel_default };